module.exports = __webpack_public_path__ + "img/kneenk-front-web.40318a01.jpg";